export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.logout.label': 'Logout',
  'component.siteSelector.playerPlaceholder': '选择玩家...',
  'component.siteSelector.loadingSites': '正在加载站点...',
  'component.siteSelector.currentSiteLobby': '当前大厅',
  'component.siteSelector.refresh': '刷新玩家',
  'component.siteSelector.playerIdentifier': '玩家',
  'component.gameLaunch.copySuccess': 'URL已复制到剪贴板',
  'component.gameLaunch.copyFailed': '复制URL失败',
  'component.gameLaunch.openNewWindow': '在新窗口中游戏',
  'component.gameLaunch.copyUrl': '复制URL',
  'component.gameLaunch.scanOrPress': '扫描二维码或点击下方开始游戏',
  'component.gameLaunch.sessionID': '会话ID:',
  'component.gameLaunch.goToMonitor': '前往监控',
  'component.gameLaunch.copyToken': '复制令牌',
  'component.gameLaunch.mobileScanInstruction': '使用手机摄像头扫描二维码',
  'component.gameLaunch.mobileTip': '使用相机应用扫描',
  'component.gameLaunch.copyForMobile': '复制移动端URL',
  'component.copyAddress': '复制地址',
  'component.copySuccess': '地址已复制',
  'component.gameLaunch.openBrowser': '在浏览器中打开',
  'component.endOfList': '列表末尾',
};
